<template>
  <div class="profile">
    <div class="profile__info">
      <Avatar
        :url="profile.photo"
        :firstName="firstName"
        :lastName="lastName"
        :size="40"
      />
      <div v-show="isOpen" class="profile__info--text">
        <div>
          <span v-if="firstName">{{ firstName + ' ' }}</span>
          <span v-if="lastName && typeof lastName === 'string'">{{
            lastName.split('')[0] + '.'
          }}</span>
        </div>
        <div>
          <Tooltip
            effect="dark"
            placement="top-start"
            :content="profile.lbl.value.user_email"
            :disabled="
              (profile.lbl.value.user_email &&
                profile.lbl.value.user_email.length < 21) ||
              !profile.lbl.value.user_email
            "
          >
            <span v-show="profile.lbl.value.user_email" class="email-text">
              {{ profile.lbl.value.user_email }}</span
            >
          </Tooltip>
        </div>
      </div>
    </div>
    <div class="profile__menu" :style="!isOpen ? 'opacity:0' : ''">
      <FormButtons
        ref="menu"
        v-if="profile"
        :buttons_menu="[[{ ...profile, colorVisualClass: 'white' }]]"
      ></FormButtons>
    </div>
  </div>
</template>
<script>
import Avatar from 'Elements/Avatar/Avatar';
import FormButtons from 'Elements/Form/FormButtons';
import Tooltip from 'Elements/Tooltip/Tooltip';
import { mixin } from '@/utils/mixins';
export default {
  mixins: [mixin],
  props: {
    profile: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    lastName() {
      return typeof this.profile.lbl?.value?.user_name === 'string'
        ? this.profile.lbl.value.user_name.split(' ')[0]
        : '';
    },
    firstName() {
      return typeof this.profile.lbl?.value?.user_name === 'string'
        ? this.profile.lbl.value.user_name.split(' ')[1]
        : '';
    }
  },
  components: { Avatar, FormButtons, Tooltip }
};
</script>

<style lang="scss" scoped>
.profile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  margin-top: 40px;
  padding-left: 16px;
  position: relative;

  &::v-deep .el-dropdown-menu {
    bottom: 0 !important;
  }

  &__menu {
    padding-right: 16px;
  }

  &__info {
    display: flex;
    justify-content: center;
    align-items: center;

    &--text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-left: 16px;
      max-width: 168px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .email-text {
        display: block;
        width: 168px !important;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
      }
    }
  }
}
@media (max-height: 830px) {
  .profile {
    margin-top: 0;
    margin-bottom: 90px;
  }
}
</style>
